import { observer } from "mobx-react-lite";
import React, { FC, useMemo, useState } from "react";
import { langStore } from "@noli/business";
import styles from "./index.module.scss";
import { loginStore } from "@/modules/login/store";
import Input from "@/pages/Setting/components/Input";
import { bindPhone, postBindEmail, pwdSet } from "@/pages/Setting/api";
import { Toast } from "@/components/Toast";
import { emailType } from "@/utils/reg";
import { SettingLangRecords } from "@/pages/Setting/lang";

const BindEmail: FC<any> = (props) => {
  const { onClose } = props;
  const lang = langStore.tgt;
  const {
    userState: { userInfo },
  } = loginStore;
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const submitState = useMemo(() => {
    return code.length === 6 && emailType(email);
  }, [code, email]);
  const submit = async () => {
    try {
      await postBindEmail({
        code: code,
        email: email,
        old_email: userInfo.email as string,
        type: 1,
      });
      await loginStore.getUserInfo();
      onClose && onClose();
      Toast({
        status: "success",
        title: SettingLangRecords[lang]["Binding-Succeeded"],
      });
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <div className={styles.contentRowWrapper} style={{ borderStyle: "none", flexFlow: "column" }}>
      <Input
        label="Email address"
        type="test"
        placeholder="Enter email address"
        value={email}
        onChange={(value: string | number) => {
          setEmail(value as string);
        }}
      />
      <Input
        phoneOrEmail={email}
        label="Code"
        type="emailCode"
        placeholder="Enter verification code"
        value={code}
        onChange={(value: string | number) => {
          setCode(value as string);
        }}
      />
      <button
        className={styles.submit}
        disabled={!submitState}
        onClick={async () => {
          await submit();
        }}
      >
        {SettingLangRecords[lang]["Confirm"]}
      </button>
    </div>
  );
};
export default observer(BindEmail);
